
import adminRoutes from './pages/admin/admin-routes';
import assetRoutes from './pages/asset/asset-routes';
import generalRoutes from './pages/general-routes';
import machineRoutes from './pages/machine/machine-routes';
import sparepartRoutes from './pages/sparepart/sparepart-routes';
import uikitRoutes from "./pages/uikit/uikit-routes";


const routes = [
    ...generalRoutes,
    ...adminRoutes,
    ...uikitRoutes,
    ...machineRoutes,
    ...sparepartRoutes
]

export default routes;